export default "__VITE_ASSET__Di0i2xin__"